// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__7FOe1","paginationButton":"Pagination_paginationButton__U2Mc5"};